import moment from "moment-timezone";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "./../redux/types";
import { Dispatcher } from "../service/RootDispather";
import { weirdData } from "../redux/residentActivityPlan";
const PlanRetriever = (): JSX.Element => {
  const rootDispatcher = Dispatcher();

  const { isBaseUrlRetrieved } = useSelector((state: IAppState) => state.auth);
  const retrieveTodayData = useCallback(() => {
    const startToday = moment().startOf("day").local();
    const start = weirdData(startToday);
    const end = weirdData(
      moment(startToday).add(1, "days").subtract(1, "milliseconds")
    );
    rootDispatcher.getResidentsActivities(start, end);
  }, [rootDispatcher]);
  useEffect(() => {
    if (isBaseUrlRetrieved) retrieveTodayData();
  }, [retrieveTodayData, isBaseUrlRetrieved]);

  const whenStartFirstRepeat = useCallback(() => {
    const now = moment();
    const local = moment().startOf("day").local();
    const startTomorrow = moment(local).add(1, "days");
    const diffTime = moment(startTomorrow).diff(now);
    if (diffTime < 0) return 0;
    const durationInMSec = moment
      .duration(diffTime, "milliseconds")
      .asMilliseconds();
    return durationInMSec;
  }, []);

  useEffect(() => {
    const firstRepeat = whenStartFirstRepeat();

    let timeoutNext;
    let firstTimeout;
    if (firstRepeat !== 0) {
      firstTimeout = setInterval(() => {
        retrieveTodayData();
        clearInterval(firstTimeout);
        timeoutNext = setInterval(() => {
          retrieveTodayData();
        }, 24 * 60 * 60 * 1000);
      }, firstRepeat);
    } else {
      timeoutNext = setInterval(() => {
        retrieveTodayData();
      }, 24 * 60 * 60 * 1000);
    }

    return () => {
      clearInterval(timeoutNext);
      if (firstTimeout) clearInterval(firstTimeout);
    };
  }, [retrieveTodayData, whenStartFirstRepeat]);
  const { socketsWorking } = useSelector(
    (state: IAppState) => state.healthCheck
  );
  const [socketIsWorking, setsocketIsWorking] = useState(socketsWorking);
  const { isAuthorized } = useSelector((state: IAppState) => state.auth);
  useEffect(() => {
    if (isAuthorized && socketsWorking === true && socketIsWorking === false) {
      //connection restored
      retrieveTodayData();
    }
    setsocketIsWorking(socketsWorking);
  }, [socketsWorking, isAuthorized, socketIsWorking, retrieveTodayData]);

  return null;
};
export default React.memo(PlanRetriever);
